<template>
  <div>
    <section class="" v-if="CardInfoDetailData != null">
      <div class="container">
        <ul class="btn-box">
          <li>
            <router-link :to="{ name: 'MemberInfo' }" tag="button">
              <img src="img/member-icon-1.svg" alt="" />
              {{ $t("會員資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'OrderList' }" tag="button">
              <img src="img/member-icon-2.svg" alt="" />
              {{ $t("我的套票") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CardInfo' }" tag="button" class="active">
              <img src="img/member-icon-6.svg" alt="" />
              {{ $t("卡片資料") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'Coupon' }" tag="button">
              <img src="img/member-icon-8.svg" alt="" />
              {{ $t("套票兌換") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'TradeRecord' }" tag="button">
              <img src="img/member-icon-4.svg" alt="" />
              {{ $t("卡片交易紀錄") }}
            </router-link>
          </li>
          <li>
            <router-link :to="{ name: 'CarbonReduction' }" tag="button">
              <img src="img/member-icon-9.png" alt="" />
              {{ $t("減碳計算") }}
            </router-link>
          </li>
          <li></li>
        </ul>
        <div class="main">
          <div class="bg-box">
            <h1>{{ $t("基本資料") }}</h1>
            <hr />
            <ul class="text-box">
              <li>
                <div>{{ $t("卡片類型") }}</div>
                <div>{{ CardInfoDetailData.CardType }}</div>
              </li>
              <li>
                <div>{{ $t("姓名") }}</div>
                <div>{{ CardInfoDetailData.Name }}</div>
              </li>
              <li>
                <div>{{ $t("出生年月") }}</div>
                <div>{{ CardInfoDetailData.Birth }}</div>
              </li>
              <li>
                <div>{{ $t("性別") }}</div>
                <div>{{ CardInfoDetailData.Sex }}</div>
              </li>
              <li>
                <div>{{ $t("國籍") }}</div>
                <div>{{ CardInfoDetailData.Nation }}</div>
              </li>
              <li>
                <div>{{ $t("身份證號") }}</div>
                <div>{{ CardInfoDetailData.Ident }}</div>
              </li>
              <li>
                <div>{{ $t("地址") }}</div>
                <div>{{ CardInfoDetailData.Address }}</div>
              </li>
              <li>
                <div>{{ $t("電話") }}</div>
                <div>{{ CardInfoDetailData.Phone }}</div>
              </li>
            </ul>
          </div>
          <hr />
          <hr
            v-if="
              CardInfoDetailData.StuImg != '' &&
              CardInfoDetailData.StuImgF != ''
            "
          />
          <div class="bg-box" v-if="CardInfoDetailData.Photo != ''">
            <h1>{{ $t("證件照片") }}</h1>
            <hr />
            <ul class="text-box">
              <li>
                <img :src="SiteUrl + CardInfoDetailData.Photo" alt="" />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <!-- 底部加高 底部固定選單fixed的高度 -->
    <div class="nav-menu-bg"></div>
  </div>
</template>

<script>
import Vue from "vue";
import axios from "axios";
import VueAxios from "vue-axios";
import AES from "@/utils/aes.js";
import CryptoJS from "crypto-js";
import VueI18n from "vue-i18n";
import Storage from "@/utils/storage.js";

Vue.use(VueAxios, axios);
Vue.use(VueI18n);

// this.$t("立即購買")
const messages = {
    zh_tw: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "基本資料": "基本資料",
    "卡片類型": "卡片類型",
    "姓名": "姓名",
    "出生年月": "出生年月",
    "性別": "性別",
    "國籍": "國籍",
    "身份證號": "身份證號",
    "地址": "地址",
    "電話": "電話",
    "身份證正反面": "身份證正反面",
    "學生證正反面": "學生證正反面",
    "證件照片": "證件照片",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
  en: {
    "會員資料": "Member info",
    "我的套票": "My pass",
    "卡片資料": "Card info",
    "套票兌換": "Redeem pass",
    "卡片交易記錄": "Card record",
    "其他資訊": "Other info",
    "基本資料": "Basic info",
    "卡片類型": "Type",
    "姓名": "Name",
    "出生年月": "Date of birth",
    "性別": "Gender",
    "國籍": "Nationality",
    "身份證號": "ID No.",
    "地址": "Address",
    "電話": "Mobile phone",
    "身份證正反面": "Front and back of the ID card",
    "學生證正反面": "Front and back of the student card",
    "證件照片": "Photo",
    "卡片交易紀錄": "Activity",
    "減碳計算": "Carbon Reduced",
  },
  jp: {
    "會員資料": "會員資料",
    "我的套票": "我的套票",
    "卡片資料": "卡片資料",
    "套票兌換": "套票兌換",
    "卡片交易記錄": "卡片交易記錄",
    "其他資訊": "其他資訊",
    "基本資料": "基本資料",
    "卡片類型": "卡片類型",
    "姓名": "姓名",
    "出生年月": "出生年月",
    "性別": "性別",
    "國籍": "國籍",
    "身份證號": "身份證號",
    "地址": "地址",
    "電話": "電話",
    "身份證正反面": "身份證正反面",
    "學生證正反面": "學生證正反面",
    "證件照片": "證件照片",
    "卡片交易紀錄": "卡片交易紀錄",
    "減碳計算": "減碳計算",
  },
};

const i18n = new VueI18n({
  locale: "zh_tw",
  messages,
});

export default {
  name: "CardInfoDetail",
  i18n,
  data() {
    return {
      SiteUrl: "",
      CardInfoDetailData: {},
      IsTester: false,
    };
  },
  watch: {},
  created: function () {
    let that = this;
    Vue.axios
      .get(
        this.GLOBAL.apiSrc +
          this.GLOBAL.subDirectory +
          "/Htmlv2/CardInfoDetail",
        {
          params: {
            token: Storage.get("ek_login_token"),
          },
        }
      )
      .then((response) => {
        this.SiteUrl = response.data.SiteUrl;
        this.CardInfoDetailData = response.data.CardInfoDetailData;
        this.IsTester = response.data.IsTester;
      })
      .catch((error) => {
        console.log(error);
      });
  },
  updated: function () {},
  mounted: function () {
    // 回頂端
    $(window).scrollTop(0);
    // 套用Class
    $(".wrapper").addClass("member");
    $(".wrapper").addClass("member-card-information-main");
    // i18n
    if (Storage.isKey("ek_site_lang")) {
      i18n.locale = Storage.get("ek_site_lang");
    } else {
      i18n.locale = "zh_tw";
    }
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CardInfoDetail.vue